/* Feature examples share the product listings' Liquid photo/description templates. */
(function(scope){
  'use strict';
  const groupFor = name => /^(wood|species|wood type)$/i.test(name) ? 'wood' : /groove/i.test(name) ? 'juice-groove' : /handle/i.test(name) ? 'handle-style' : /feet/i.test(name) ? 'installed-feet' : null;
  const valueFor = value => value === 'Juice Groove' ? 'Top Juice Groove' : value;
  class CorporateFeatureExamples {
    constructor(root){
      this.root=root;this.product=null;
      this.templates=[...root.querySelectorAll('[data-feature-example]')];
      this.dialog=root.querySelector('[data-feature-dialog]');
      this.dialog.querySelector('[data-feature-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',event=>{if(event.target!==this.dialog)return;const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();});
    }
    template(group,value){
      const normalized=valueFor(value);
      const specialized=group==='juice-groove'&&this.product?.handle.includes('end-grain')?'juice-groove-end-grain':group;
      return this.templates.find(t=>t.dataset.featureGroup===specialized&&t.dataset.featureValue===normalized)||this.templates.find(t=>t.dataset.featureGroup===group&&t.dataset.featureValue===normalized);
    }
    attach(field,select,name){
      const group=groupFor(name);if(!group)return;
      field.classList.add('gifting-feature');field.dataset.featureField=group;
      const row=document.createElement('div');row.className='gifting-feature__row';
      const choice=document.createElement('div');choice.className='gifting-feature__choice';choice.append(...field.childNodes);
      const button=document.createElement('button');button.type='button';button.className='gifting-feature__photo';button.setAttribute('aria-label',`Compare ${name} Options`);button.setAttribute('aria-haspopup','dialog');
      button.addEventListener('click',()=>this.open(select,group,name));
      const description=document.createElement('p');description.className='gifting-feature__description';
      row.append(button,choice);field.append(row,description);
    }
    update(product){
      this.product=product;
      for(const field of this.root.querySelectorAll('[data-feature-field]')){
        const select=field.querySelector('select'),template=this.template(field.dataset.featureField,select.value),button=field.querySelector('.gifting-feature__photo'),description=field.querySelector('.gifting-feature__description');
        button.hidden=!template;description.hidden=!template;
        if(!template){delete field.dataset.featureCurrent;continue;}
        const key=template.dataset.featureGroup+':'+template.dataset.featureValue;
        if(field.dataset.featureCurrent===key)continue;
        field.dataset.featureCurrent=key;
        const photo=template.content.querySelector('.option-photo').cloneNode(true);
        const caption=document.createElement('span');caption.textContent='Compare';
        button.replaceChildren(photo,caption);
        const copy=template.content.querySelector('[data-feature-description]').textContent.trim();
        description.textContent=copy.split(/(?<=\.)\s+/)[0];
      }
    }
    open(select,group,name){
      this.dialog.querySelector('[data-feature-title]').textContent=`Compare ${name}`;
      this.dialog.querySelector('[data-feature-note]').textContent=group==='wood'?'Wood Color Examples. Grain Varies By Board And Construction.':'Feature Examples. Board Style And Wood May Vary; Other Features Are Selected Separately.';
      const options=this.dialog.querySelector('[data-feature-options]');options.replaceChildren();
      for(const option of select.options){
        if(option.disabled)continue;
        const template=this.template(group,option.value);if(!template)continue;
        const card=document.createElement('div');card.className='gifting-feature-card';
        const selected=option.value===select.value;
        card.classList.toggle('is-selected',selected);
        const photo=template.content.querySelector('.option-photo').cloneNode(true);
        const title=document.createElement('h3');title.textContent=option.textContent;
        const description=template.content.querySelector('[data-feature-description]').cloneNode(true);
        const button=document.createElement('button');button.type='button';button.className='button';button.textContent=selected?'Selected':'Choose This';button.setAttribute('aria-label',`${selected?'Selected':'Choose'} ${option.textContent}`);button.disabled=selected;
        button.addEventListener('click',()=>{select.value=option.value;select.dispatchEvent(new Event('change',{bubbles:true}));this.dialog.close();});
        card.append(photo,title,description,button);options.append(card);
      }
      this.dialog.showModal();
    }
  }
  scope.RefineCorporateFeatures=CorporateFeatureExamples;
  if(typeof module!=='undefined')module.exports={groupFor,valueFor,CorporateFeatureExamples};
})(typeof window!=='undefined'?window:globalThis);
